(() => {
  if (window.ifCommentValidation) return;
  const selector = 'textarea[data-comment-min]';
  const messages = document.querySelector('script[data-comment-validation]')?.dataset || {};
  const lines = (value) => String(value).split(/\r\n?|\n/).map((line) => line.trim()).filter(Boolean);
  let sequence = 0;
  const limits = (handle) => {
    const match = /^(\d[\d,]*)-(facebook|instagram|youtube|threads)-comments(?:-|$)/.exec(handle || '');
    return match ? { min: match[2] === 'facebook' ? 10 : match[2] === 'threads' ? 1 : 5, max: Number(match[1].replaceAll(',', '')) } : null;
  };
  function bounds(field) {
    let max = Number(field.dataset.commentMax);
    const component = field.closest('product-form');
    if (component) {
      const variant = field.form?.querySelector('[data-variant-id]')?.value;
      const radio = Array.from(component.querySelectorAll('[data-package] input[data-variant-id]'))
        .find((input) => input.dataset.variantId === variant);
      max = Number(radio?.dataset.commentMax);
    }
    return { min: Number(field.dataset.commentMin), max };
  }
  function sync(field, report = false) {
    if (!field.matches(selector) || field.disabled) return true;
    const { min, max } = bounds(field);
    const count = lines(field.value).length;
    const hasPackage = Number.isInteger(min) && min > 0 && Number.isInteger(max) && max >= min;
    const valid = hasPackage && count >= min && count <= max;
    const message = hasPackage
      ? (messages.range || '').replaceAll('__MIN__', min).replaceAll('__MAX__', max).replaceAll('__COUNT__', count)
      : messages.package;
    field.setCustomValidity(valid ? '' : (message || 'Please check the comment count.'));
    let hint = field.nextElementSibling;
    if (!hint?.hasAttribute('data-comment-hint')) {
      hint = document.createElement('p');
      hint.dataset.commentHint = '';
      hint.id = `if-comment-hint-${++sequence}`;
      hint.setAttribute('aria-live', 'polite');
      hint.style.cssText = 'margin:6px 0 0;font-size:12px;line-height:1.5;';
      field.after(hint);
      field.setAttribute('aria-describedby', [field.getAttribute('aria-describedby'), hint.id].filter(Boolean).join(' '));
    }
    hint.textContent = message || field.validationMessage;
    const showError = !valid && (report || field.dataset.commentReported === 'true' || count > 0);
    hint.style.color = showError ? '#b91c1c' : 'inherit';
    field.setAttribute('aria-invalid', String(showError));
    if (report && !valid) {
      field.dataset.commentReported = 'true';
      field.focus();
      field.reportValidity();
    }
    return valid;
  }
  function validateForm(form) {
    const fields = Array.from(form.elements).filter((field) => field.matches(selector));
    let firstInvalid;
    for (const field of fields) if (!sync(field) && !firstInvalid) firstInvalid = field;
    if (firstInvalid) sync(firstInvalid, true);
    return !firstInvalid;
  }
  function refresh(root = document) {
    root.querySelectorAll(selector).forEach((field) => sync(field));
  }
  window.ifCommentValidation = { lines, limits, sync, validateForm, refresh };
  document.addEventListener('input', (event) => {
    if (event.target.matches(selector)) sync(event.target);
  });
  document.addEventListener('submit', (event) => {
    if (event.target instanceof HTMLFormElement && !validateForm(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[type="submit"],input[type="submit"]');
    if (button?.form && !validateForm(button.form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh());
  else refresh();
})();


